import React from "react";
import { useTranslation } from "react-i18next";

import * as Icons from "assets/icons";

// import { useAll as useSpheres } from "modules/sphere/hooks";
import { useAll as useOrganizations } from "modules/organization/hooks";
import { useAll as useOkeds } from "modules/oked/hooks";

import * as Grid from "components/Grid";

import Select from "components/Select";
import Button from "components/Button";
import { useEnums } from "hooks";

const FilterList = ({ params, setParams, setSearch }) => {
  const { t, i18n } = useTranslation();

  // const sphere = useSpheres();
  const organization = useOrganizations();
  const oked = useOkeds();

  const { items: registerRequirementTypes, isFetched: isRegisterRequirementTypesFetched } = useEnums("RegisterRequirementsType");

  return (
    <Grid.Row style={{
      flex: "1",
    }} gutter={[16, 8]}>
      <Grid.Col xs={8}>
        <Select
          onChange={v => setParams({ organizationId: v })}
          showSearch
          options={[
            { label: t("all_organization"), value: "" },
            ...organization.items.map(item => ({
              label: item.name[i18n.language],
              value: item.id,
            })),
          ]}
          value={Number(params.organizationId) || ""}
          placeholder={t("column_organization")}
          disabled={!organization.isFetched}
        />
      </Grid.Col>

      <Grid.Col xs={8}>
        <Select
          onChange={v => setParams({ okedId: v })}
          showSearch
          options={[
            { label: t("all_oked"), value: "" },
            ...oked.items.map(item => ({ label: item.name[i18n.language], value: item.id })),
          ]}
          value={Number(params.okedId) || ""}
          placeholder={t("column_oked")}
          disabled={!oked.isFetched}
        />
      </Grid.Col>

      <Grid.Col xs={4}>
        <Select
          onChange={e => setParams({ type: e })}
          options={registerRequirementTypes.length > 0 &&
            isRegisterRequirementTypesFetched ?
            registerRequirementTypes.map(item => ({
              label: t(item),
              value: item,
            })) : []}
          placeholder={t("column_type")}
          value={params.type || ""}
        />
      </Grid.Col>

      <Grid.Col xs={2}>
        <Button
          background="blue"
          color="white"
          border="blue"
          radius="sm"
          onClick={() => setSearch(prev => prev + 1)}>
          <Icons.Search /> {t("find")}
        </Button>
      </Grid.Col>
    </Grid.Row>
  );
};

export default FilterList;
